import { createContext, useContext } from "react";

/** True where Home sits in the page card, on white, where the soft shadows drawn for the gray page read as halos. */
export const HomeInCardContext = createContext(false);

export const useIsHomeInCard = () => useContext(HomeInCardContext);

/** A surface's edge on the card: a hairline in place of a shadow. */
export const HOME_CARD_EDGE = {
  borderWidth: "hairline",
  borderStyle: "solid",
  borderColor: "base.border",
  boxShadow: "none",
} as const;
